import type { DEVICE_TYPES } from '../types/Blocks'
import { devices as devicesWithoutTypes } from './devicesList.js'

export const devices = devicesWithoutTypes as {
  [key in DEVICE_TYPE]: DEVICE_INFO
}

export const devicesArray = Object.values(devices)

export const useDevices = () => {
  const { t } = useI18n()
  const deviceType = useState<DEVICE_TYPES>('device-type', () => 'pc')

  const deviceNames = computed<{ [key in DEVICE_TYPE]: string }>(() => ({
    pc: t('Počítač'),
    tablet: t('Tablet'),
    mobile: t('Telefon'),
  }))

  const deviceNameHelper = computed<{ [key in DEVICE_TYPE]: string }>(() => ({
    pc: t('na počítači'),
    tablet: t('na tabletu'),
    mobile: t('na telefonu'),
  }))

  return { deviceNames, deviceNameHelper, deviceType }
}

export type DEVICE_TYPE = 'pc' | 'tablet' | 'mobile'
export type DEVICE_INFO = {
  value: DEVICE_TYPE
  icon: string
  width: string
  height: string
  minWidth: string
  minHeight: string
  prefix?: string
  index: number
}
